import { Drawer } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import renderHTML from "react-render-html";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
export const RemarkPane = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  return (
    <Drawer
      title={naocDailyProductionStore.remarkObj?.title}
      placement="right"
      width={"30%"}
      closable={true}
      destroyOnClose={true}
      onClose={() => {
        naocDailyProductionStore.showRemarkPane = false;
      }}
      visible={naocDailyProductionStore.showRemarkPane}
    >
      {naocDailyProductionStore.remarkObj &&
        renderHTML(naocDailyProductionStore?.remarkObj?.remark)}
    </Drawer>
  );
});

